"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Slider = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var ReversePortals = _interopRequireWildcard(require("react-reverse-portal"));
var _useMeasure = _interopRequireDefault(require("../../hooks/useMeasure"));
var _Portal = _interopRequireDefault(require("../Portal"));
var _environment = _interopRequireDefault(require("../../utils/environment"));
var _SliderContext = require("./contexts/SliderContext");
var _types = require("./types");
var Styled = _interopRequireWildcard(require("./style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var Slider = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var index = props.index,
    onChange = props.onChange,
    children = props.children,
    onNext = props.onNext,
    onPrevious = props.onPrevious,
    onKeyDown = props.onKeyDown,
    onFullscreenChange = props.onFullscreenChange,
    loop = props.loop,
    _a = props.slidesCount,
    slidesCount = _a === void 0 ? 0 : _a,
    shouldAutoPlay = props.shouldAutoPlay,
    duration = props.duration,
    autoWidth = props.autoWidth,
    dynamicBullets = props.dynamicBullets,
    _b = props.direction,
    direction = _b === void 0 ? _types.SliderDirections.Horizontal : _b,
    _c = props.variant,
    variant = _c === void 0 ? _types.SliderVariants.Primary : _c,
    _d = props.size,
    size = _d === void 0 ? _types.SliderSizes.Normal : _d,
    fullscreenClassName = props.fullscreenClassName,
    filteredProps = __rest(props, ["index", "onChange", "children", "onNext", "onPrevious", "onKeyDown", "onFullscreenChange", "loop", "slidesCount", "shouldAutoPlay", "duration", "autoWidth", "dynamicBullets", "direction", "variant", "size", "fullscreenClassName"]);
  var portalNode = (0, _react.useMemo)(function () {
    if (_environment.default.isClient) {
      return ReversePortals.createHtmlPortalNode({
        attributes: {
          class: "fluffy-slider-portal-node"
        }
      });
    } else {
      return null;
    }
  }, []);
  var indexMultiplierRef = (0, _react.useRef)(0);
  var _e = (0, _react.useState)(null),
    wrapperElement = _e[0],
    setWrapperElement = _e[1];
  var _f = (0, _react.useState)(slidesCount),
    slidesLength = _f[0],
    setSlidesLength = _f[1];
  var _g = (0, _react.useState)(null),
    sliderInstance = _g[0],
    setSliderInstance = _g[1];
  var _h = (0, _react.useState)(false),
    isFullscreen = _h[0],
    setIsFullscreen = _h[1];
  var _j = (0, _react.useState)(false),
    isFullscreenSupported = _j[0],
    setIsFullscreenSupported = _j[1];
  var _k = (0, _useMeasure.default)(wrapperElement),
    wrapperRect = _k.rect,
    revalidateWrapperRect = _k.revalidate;
  (0, _react.useEffect)(function () {
    if (typeof onFullscreenChange === 'function') {
      onFullscreenChange(isFullscreen);
    }
  }, [onFullscreenChange, isFullscreen]);
  var getSlidesSet = (0, _react.useCallback)(function () {
    var slidesSet = __spreadArray([], new Array(slidesLength), true).map(function (_, idx) {
      if (indexMultiplierRef.current === 0) {
        return idx;
      } else {
        return idx + slidesLength * indexMultiplierRef.current;
      }
    });
    return slidesSet;
  }, [slidesLength]);
  var getMultiplayer = (0, _react.useCallback)(function (newIndex) {
    var slidesSet = getSlidesSet();
    if (!slidesSet.includes(newIndex)) {
      if (newIndex > slidesSet[slidesSet.length - 1]) {
        indexMultiplierRef.current = indexMultiplierRef.current + 1;
      } else {
        indexMultiplierRef.current = indexMultiplierRef.current - 1;
      }
    }
  }, [getSlidesSet]);
  var getIndexBySlide = (0, _react.useCallback)(function (slide) {
    var slidesSet = getSlidesSet();
    return slidesSet.findIndex(function (item) {
      return item === slide;
    });
  }, [getSlidesSet]);
  var getSlideByIndex = (0, _react.useCallback)(function (index) {
    var slidesSet = getSlidesSet();
    return slidesSet[index] || slidesSet[0] || 0;
  }, [getSlidesSet]);
  var handleSetSliderInstance = (0, _react.useCallback)(function (instance) {
    setSliderInstance(instance);
  }, []);
  var handleOnChange = (0, _react.useCallback)(function (newIndex) {
    getMultiplayer(newIndex);
    if (typeof onChange === 'function') {
      onChange(getIndexBySlide(newIndex));
    }
  }, [getIndexBySlide, getMultiplayer, onChange]);
  var goToIndex = (0, _react.useCallback)(function (newIndex) {
    if (sliderInstance) {
      sliderInstance === null || sliderInstance === void 0 ? void 0 : sliderInstance.handleChangeIndex(newIndex, index);
    }
  }, [index, sliderInstance]);
  var handleOnNextSlide = (0, _react.useCallback)(function () {
    goToIndex(index + 1);
    if (typeof onNext === 'function') {
      onNext();
    }
  }, [goToIndex, index, onNext]);
  var handleOnPreviousSlide = (0, _react.useCallback)(function () {
    goToIndex(index - 1);
    if (typeof onPrevious === 'function') {
      onPrevious();
    }
  }, [goToIndex, index, onPrevious]);
  var handleOnKeyDown = (0, _react.useCallback)(function (event) {
    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
    }
    switch (event.code) {
      case 'ArrowLeft':
      case 'ArrowUp':
        {
          handleOnPreviousSlide();
          break;
        }
      case 'ArrowRight':
      case 'ArrowDown':
        {
          handleOnNextSlide();
          break;
        }
    }
  }, [handleOnNextSlide, handleOnPreviousSlide, onKeyDown]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      goNext: handleOnNextSlide,
      goBack: handleOnPreviousSlide,
      revalidateWrapperRect: revalidateWrapperRect,
      _domElement: wrapperElement
    };
  }, [handleOnNextSlide, handleOnPreviousSlide, revalidateWrapperRect, wrapperElement]);
  var context = (0, _react.useMemo)(function () {
    return {
      index: index,
      variant: variant,
      size: size,
      loop: loop,
      direction: direction,
      wrapperElement: wrapperElement,
      wrapperRect: wrapperRect,
      slidesLength: slidesCount || slidesLength,
      shouldAutoPlay: shouldAutoPlay,
      duration: duration,
      dynamicBullets: dynamicBullets,
      autoWidth: autoWidth,
      revalidateWrapperRect: revalidateWrapperRect,
      onChange: handleOnChange,
      setSliderInstance: handleSetSliderInstance,
      setSlidesLength: setSlidesLength,
      getSlideByIndex: getSlideByIndex,
      onNext: handleOnNextSlide,
      onPrevious: handleOnPreviousSlide,
      goToIndex: goToIndex,
      setIsFullscreen: setIsFullscreen,
      setIsFullscreenSupported: setIsFullscreenSupported
    };
  }, [index, variant, size, loop, direction, wrapperElement, wrapperRect, slidesCount, slidesLength, shouldAutoPlay, duration, autoWidth, dynamicBullets, revalidateWrapperRect, handleOnChange, handleSetSliderInstance, getSlideByIndex, handleOnNextSlide, handleOnPreviousSlide, goToIndex, setIsFullscreen, setIsFullscreenSupported]);
  var sliderContent = (0, _jsxRuntime.jsx)(Styled.Wrapper, __assign({}, filteredProps, {
    onKeyDown: handleOnKeyDown,
    tabIndex: 0,
    ref: setWrapperElement
  }, {
    children: children
  }));
  return (0, _jsxRuntime.jsxs)(_SliderContext.SliderContext.Provider, __assign({
    value: context
  }, {
    children: [_environment.default.isClient ? (0, _jsxRuntime.jsx)(ReversePortals.InPortal, __assign({
      node: portalNode
    }, {
      children: sliderContent
    })) : sliderContent, isFullscreen && !isFullscreenSupported ? (0, _jsxRuntime.jsx)(_Portal.default, {
      children: (0, _jsxRuntime.jsx)(Styled.FullscreenWrapper, __assign({
        className: fullscreenClassName
      }, {
        children: (0, _jsxRuntime.jsx)(ReversePortals.OutPortal, {
          node: portalNode
        })
      }))
    }) : _environment.default.isClient ? (0, _jsxRuntime.jsx)(ReversePortals.OutPortal, {
      node: portalNode
    }) : null]
  }));
});
exports.Slider = Slider;
Slider.displayName = 'Slider';
var _default = Slider;
exports.default = _default;